import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { MaterialLayoutSchema } from "../generated/prisma/zod";
import { makeCreateInputSchema } from "../utils/zod-utils/makeCreateInputSchema";

const c = initContract();

export const materialLayoutsContract = c.router({
  create: {
    path: "/material-layouts",
    method: "POST",
    body: makeCreateInputSchema(MaterialLayoutSchema).omit({ volume: true }).extend({
      layoutId: z.string(),
      quoteRequestId: z.string(),
    }),
    responses: {
      201: z.object({
        materialLayout: MaterialLayoutSchema,
        otherCreatedData: z.array(
          z.object({ materialLayout: MaterialLayoutSchema, quoteRequestLineId: z.string() }),
        ),
      }),
    },
  },
  update: {
    path: "/material-layouts/:id",
    method: "PUT",
    body: z
      .object({
        data: MaterialLayoutSchema.pick({
          length: true,
          width: true,
          height: true,
          tubeThickness: true,
          density: true,
          price: true,
          materialId: true,
          volumetricPrice: true,
          materialVolumetricId: true,
        }),
      })
      .extend({
        applyToAllSiblings: z.boolean().default(false),
      }),
    responses: {
      200: z.object({
        materialLayoutIds: z.array(z.string()),
        quoteRequestLineIds: z.array(z.string()),
      }),
    },
  },
  updateNesting: {
    path: "/material-layouts/:id/nesting",
    method: "PATCH",
    body: MaterialLayoutSchema.pick({
      maxPartsPerLayout: true,
    }),
    responses: {
      200: MaterialLayoutSchema,
    },
  },
});
